import React, { Component } from "react";
import { trans, alert } from "../../Lang";

class CourseDetailHeader extends Component {
  render() {
    const { instructor, title } = this.props;
    return (
      <div className="row mb-0">
        <h5 id="top-course-title">{title}</h5>
        <h6>
          {trans.instructor}: {instructor}
        </h6>
      </div>
    );
  }
}

export default CourseDetailHeader;



// WEBPACK FOOTER //
// ./src/components/Course/components/CourseHeader.js